<template>
  <v-overlay :value="mainSpinner" color="rgba(2, 16, 48, 1)" z-index="1000">
    <v-progress-circular size="125" color="white" indeterminate>
        <img height="125px" :src="imageLogoUrlWhite" />
    </v-progress-circular>
    <!-- <p class="text-center mt-4 font-weight-medium text-h6">Loading...</p> -->
  </v-overlay>
</template>

<script>
export default {
  computed: {
    mainSpinner () {
      return this.$root.spinners.main
    }
  },
  watch: {
    // mainSpinner: {
    //   handler (x, y) {
    //     const vuetifyClass = document.querySelector('.v-application--wrap')
    //     console.log(vuetifyClass)
    //     if (x) {
    //       vuetifyClass.classList.add('stop-scrolling')
    //     } else {
    //       vuetifyClass.classList.remove('stop-scrolling')
    //     }
    //   },
    //   immediate: true
    // }
  }

}
</script>

<style lang="scss" scoped>
.stop-scrolling {
  height: 100%;
  overflow: hidden;
}
.image {
  position: absolute;
}

.image img {
  position: absolute;
  top: 25%;
  left: 26%;
}

.spin {
  position: relative;
  display: inline-block;
  width: 20vh;
  height: 20vh;
  border: 2px solid #34495e;
  border-radius: 100%;
  animation: spin 0.75s infinite linear;
}

// .spin::before,
// .spin::after {
//   left: -2px;
//   top: -2px;
//   display: none;
//   position: absolute;
//   content: "";
//   width: inherit;
//   height: inherit;
//   border: inherit;
//   border-radius: inherit;
// }
</style>
